import { ReactNode, useMemo, CSSProperties, forwardRef, FC, useRef, useCallback, } from 'react';
import { Input } from 'antd';
import { InputProps as InputCopyProps } from 'antd/lib/input';
import './style.less';

export type InputProps = InputCopyProps;
export interface NewInputProps extends InputProps {
  company?: ReactNode;
  companyWidth?: number;
  /** 输入框的字符自动转换成大写 */
  isUpperCase?: boolean;
}

const ProInput: FC<NewInputProps> = forwardRef<any, NewInputProps>(
  (props, ref) => {
    const { children, company, companyWidth, isUpperCase, style, onChange, ...resProps } = props;
    // const conditionRef = useRef({
    //   changeEvent: null as unknown as React.ChangeEvent<HTMLInputElement>,
    //   doNotChange: false,
    // });
    // const handleKeyUp = useCallback((event: any) => {
    //   const inputValue = event.target.value;
    //   if (typeof inputValue === 'string') {
    //     let newInputValue = inputValue.trimStart();
    //     if (isUpperCase && newInputValue) {
    //       newInputValue = newInputValue.toUpperCase();
    //     }
    //     event.target.value = newInputValue;
    //   }
    //   onKeyUp?.(event);
    //   onChange?.(event);
    // }, [isUpperCase]);
    const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
      const inputValue = event.target.value;
      if (typeof inputValue === 'string') {
        let newInputValue = inputValue.trimStart();
        if (isUpperCase && newInputValue) {
          newInputValue = newInputValue.toUpperCase();
        }
        event.target.value = newInputValue;
      }
      onChange?.(event);
    }, [isUpperCase]);
    // const handleCompositionStart = useCallback(() => {
    //   conditionRef.current.doNotChange = true;
    // }, []);
    // const handleCompositionEnd = useCallback((event: React.CompositionEvent<HTMLInputElement>) => {
    //   conditionRef.current.doNotChange = false;
    //   handleKeyUp(event);
    // }, []);
    const styles: CSSProperties = useMemo(() => {
      const currentStyle: CSSProperties = { ...style };
      if (company && companyWidth !== undefined) {
        currentStyle.width = `calc(100% - ${companyWidth}px)`;
        currentStyle.borderTopRightRadius = 0;
        currentStyle.borderBottomRightRadius = 0;
      }
      return currentStyle;
    }, [style, company, companyWidth]);
    const companyStyle: CSSProperties = useMemo(() => {
      if (companyWidth !== undefined) return { width: companyWidth };
      return {};
    }, [companyWidth]);
    return (
      <div className="yb-input-wrap" style={style}>
        <Input
          ref={ref}
          style={styles}
          {...resProps}
          // onKeyUp={handleKeyUp}
          onChange={handleChange}
          // onCompositionStart={handleCompositionStart}
          // onCompositionEnd={handleCompositionEnd}
        >
          {children}
        </Input>
        {!!company && (
          <div className="yb-input-company" style={companyStyle}>
            {company}
          </div>
        )}
      </div>
    );
  },
);

ProInput.defaultProps = {
  companyWidth: 28,
};

export default ProInput;
